function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h78v78H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(-1 0 0 1 78 0)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FACDCD",
  fillRule: "nonzero",
  d: "M55.817 36.041l-.013-.02A23.639 23.639 0 0 1 59.5 48.75c0 13.117-10.633 23.75-23.75 23.75S12 61.867 12 48.75 22.633 25 35.75 25c7.561 0 14.297 3.534 18.647 9.04l-.029-.036 3.771-2.676-.015-.03A9.707 9.707 0 0 1 57 26.75a9.71 9.71 0 0 1 1.007-4.32l.002-.005-11.283-7.521.017-.016a5.75 5.75 0 1 1 1.437-2.24l-.066.177 11.284 7.521.024-.027A9.727 9.727 0 0 1 66.75 17c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75a9.724 9.724 0 0 1-7.158-3.13l-.004-.004-3.77 2.675zM35.75 27.5c-11.736 0-21.25 9.514-21.25 21.25S24.014 70 35.75 70 57 60.486 57 48.75 47.486 27.5 35.75 27.5zm19.3 7.407l.081.113-.012-.017a23.822 23.822 0 0 0-.068-.096zm-.33-.448l.094.124a23.84 23.84 0 0 0-.093-.124zM66.75 19.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5zm-7.468 13.519l.03.035a9.804 9.804 0 0 1-.03-.035zm-.753-1.025l.036.056a9.76 9.76 0 0 1-.036-.056zm-.2-.326l-.19-.34c.068.128.14.254.213.378l-.023-.038zm-.11-9.643l-.015.028.015-.028zm.236-.402l-.041.068.041-.068zm.158-.246l.034-.052-.009.014a9.758 9.758 0 0 0-.025.038zm.29-.414l-.025.034.024-.034zm.258-.335l.237-.282a9.8 9.8 0 0 0-.282.339l.045-.057zm-12.173-5.992l-.076.082-.186.186c.09-.086.177-.176.262-.268zm.132-.148l.034-.041.008-.01a5.783 5.783 0 0 1-.042.05zm.258-.325l-.05.067.05-.067zM42.75 7.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5zm4.8 6.418l-.018.026a5.76 5.76 0 0 1 .017-.026zm.174-.282l-.055.094.055-.094zm.283-.554l-.034.077.034-.077z",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E66A6A",
  fillRule: "nonzero",
  d: "M48.833 54.09L38.347 36.606c-1.144-1.808-4.004-1.808-5.148 0L22.649 54.09c-1.144 1.869.318 4.16 2.542 4.16h21.163c2.288 0 3.623-2.412 2.479-4.16zm-13.092.181c-.826 0-1.589-.723-1.589-1.507 0-.784.763-1.507 1.589-1.507s1.589.723 1.589 1.507c0 .844-.763 1.507-1.59 1.507zM37.33 47.7c0 .783-.763 1.507-1.59 1.507-.825 0-1.588-.603-1.588-1.507v-4.402c0-.783.763-1.507 1.589-1.507s1.589.724 1.589 1.507V47.7z",
  mask: "url(#b)"
}));

var SvgWrongNetwork = function SvgWrongNetwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrongNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrong_network.b62c647e.svg";
export { ForwardRef as ReactComponent };